/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import Category from "../../models/Category";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import { Dropdown } from "primereact/dropdown";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    categoryCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    categoryDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    categoryStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    categoryUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    categoryUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function CategoryView() {
    let empty: Category = {
        categoryCd: '',
        categoryDesc: '',
        categoryStatus: '',
        categoryUpdTs: '',
        categoryUpdUser: ''
    };

    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const [listValues, setListValues] = useState<Category[]>([]);
    const [listFilteredData, setListFilteredData] = useState<Category[]>([]);
    const [singleValue, setSingleValue] = useState<Category>(empty);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
        MaintenanceService.getCategories().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getCategories().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: Category) => [
            item.categoryCd,
            item.categoryDesc,
            item.categoryStatus,
            item.categoryUpdTs,
            item.categoryUpdUser
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Category Code', 'Category Description', 'Status', 'Last Update Date', 'Last Update User']], body: bodyData })
                doc.save('categories.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const categoryCdTemplate = (rowData: Category) => {
        return rowData.categoryCd;
    }

    const categoryDescTemplate = (rowData: Category) => {
        return rowData.categoryDesc;
    }

    const categoryStatusTemplate = (rowData: Category) => {
        return rowData.categoryStatus;
    }

    const categoryUpdTsTemplate = (rowData: Category) => {
        return rowData.categoryUpdTs;
    }

    const categoryUpdUserTemplate = (rowData: Category) => {
        return rowData.categoryUpdUser;
    }

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };
        _value.categoryCd = data.categoryCd;
        _value.categoryDesc = data.categoryDesc;
        _value.categoryStatus = data.categoryStatus;

        if (accounts[0]) {
            _value.categoryUpdTs = new Date().toISOString();
            _value.categoryUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };

    const save = (value: Category) => {
        MaintenanceService.addCategory(value).then((data) => {
            if (data) {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Category Created', life: 3000 });
                setSingleValue(empty);
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Category', life: 3000 });
            }
        });
    }

    const update = (value: Category, oldId: string) => {
        MaintenanceService.updateCategory(value, oldId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Category Updated', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Category', life: 3000 });
        });
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<Category[]>) => {
        let selectedIndex = listValues.findIndex(v => v.categoryCd === (rowData.value as Category).categoryCd);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].categoryCd}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.categoryCd === newData.categoryCd);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'categoryCd':
                return categoryCdEditor(options);

            case 'categoryDesc':
                return categoryDescEditor(options);

            case 'categoryStatus':
                return categoryStatusEditor(options);
        }
    }

    const categoryCdEditor = (options: any) => {
        return (
            <Controller
                name="categoryCdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Code is required.',
                    maxLength: {
                        value: 2,
                        message: 'Code must be at most 2 characters.',
                    },
                    validate: {
                        unique: v => listValues.filter(val => val.categoryCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Code code must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    singleValue.categoryCd = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={2} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.categoryCd = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Code" />
                        </>
                    )
                }
                }
            />
        );
    }

    const categoryDescEditor = (options: any) => {
        return (
            <Controller
                name="categoryDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.',
                    maxLength: {
                        value: 25,
                        message: 'Description must be at most 25 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.categoryDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={25} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.categoryDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }
                }
            />
        );
    }

    const categoryStatusEditor = (options: any) => {
        return (
            <Controller
                name="categoryStatusEdit"
                defaultValue={options.value}
                control={formEdit.control}
                rules={{
                    required: 'Status is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.categoryStatus = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={status} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.categoryStatus = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const rowEditorTemplate = (rowData: Category, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("categoryCdEdit").invalid && !formEdit.getFieldState("categoryDescEdit").invalid) {                            
                            let _singleValue = { ...singleValue };
                            let oldId = rowData.categoryCd;

                            if (accounts[0]) {
                                _singleValue.categoryUpdTs = new Date().toISOString();
                                _singleValue.categoryUpdUser = accounts[0].username.split('@')[0];
                            }

                            update(_singleValue, oldId);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: Category) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteCategory(singleValue.categoryCd).then(() => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Category" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="categoryCd"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Code is required.',
                                    maxLength: {
                                        value: 2,
                                        message: 'Code must be at most 2 characters.',
                                    },
                                    validate: {
                                        unique: v => listValues.filter(val => val.categoryCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Code code must be unique.'
                                    }
                                }}
                                render={({ field, fieldState }) => (

                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Category Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={2} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Category Code" />
                                        {getErrorMessage('categoryCd')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="categoryDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.',
                                    maxLength: {
                                        value: 25,
                                        message: 'Description must be at most 25 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Category Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Category Description" />
                                        {getErrorMessage('categoryDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="categoryStatus"
                                defaultValue={'A'}
                                control={form.control}
                                rules={{
                                    required: 'Status is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Status</label>
                                        <Dropdown inputId={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('categoryStatus')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="categoryCd" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} header={header} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No category records found.">
                <Column field="categoryCd" header="Category Code" sortable body={categoryCdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="categoryDesc" header="Category Description" sortable body={categoryDescTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="categoryStatus" header="Status" sortable body={categoryStatusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="categoryUpdTs" header="Last Update Date" sortable body={categoryUpdTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="categoryUpdUser" header="Last Update User" sortable body={categoryUpdUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.categoryCd} - {singleValue.categoryDesc}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}